exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Comfortaa:300|Lato:300);", ""]);

// module
exports.push([module.id, "*{box-sizing:border-box;font-family:Lato,sans-serif}h1,h2,h3,h4,h5,h6{font-family:Comfortaa,sans-serif}p{font-family:Lato,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/main.css
// module id = ./src/layouts/main.css
// module chunks = 7489246917808536000 7723607424418816000